module.exports = __webpack_public_path__ + "static/media/digital-w3-banner.122d720a.png";